import { Injectable } from '@angular/core';
import { PropertyService } from './property.service';
import { Observable, of } from 'rxjs';
import { properties } from '../../../mockDB/properties';
import { Property } from '../../../model/property';

@Injectable({
  providedIn: 'root'
})
export class MockPropertyService extends PropertyService {

  constructor() {
    super();
  }

  getMroProperties(): Observable<Property[]> {
    return of(properties);
  }
}
